import { Controller } from "@hotwired/stimulus"

// Cookie consent controller
// Manages the cookie consent banner and saves user preferences
export default class extends Controller {
  static values = {
    saveUrl: String
  }

  connect() {
    // Check if consent has already been given (stored in localStorage)
    const consentGiven = localStorage.getItem('cookie_consent_given')

    if (!consentGiven) {
      // Show the banner after a short delay
      setTimeout(() => {
        this.element.classList.remove('hidden')
      }, 1000)
    }
  }

  // Accept all cookies (essential + analytics)
  acceptAll() {
    this.saveConsent({ analytics: true })
  }

  // Accept only essential cookies
  acceptEssential() {
    this.saveConsent({ analytics: false })
  }

  async saveConsent(preferences) {
    // Hide the banner immediately for better UX
    this.element.classList.add('hidden')

    // Store in localStorage so we don't show the banner again
    localStorage.setItem('cookie_consent_given', 'true')
    localStorage.setItem('cookie_consent_analytics', preferences.analytics.toString())

    // Get or create visitor ID
    let visitorId = localStorage.getItem('cookie_visitor_id')
    if (!visitorId) {
      visitorId = crypto.randomUUID()
      localStorage.setItem('cookie_visitor_id', visitorId)
    }

    // Save to server
    try {
      const response = await fetch(this.saveUrlValue, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]')?.content
        },
        body: JSON.stringify({
          visitor_id: visitorId,
          analytics: preferences.analytics
        })
      })

      if (!response.ok) {
        console.error('Failed to save cookie consent')
      }
    } catch (error) {
      console.error('Error saving cookie consent:', error)
    }

    // If analytics is enabled, we would initialize Google Analytics here
    // For now, just log the decision
    if (preferences.analytics) {
      console.log('Analytics cookies accepted')
      // TODO: Initialize Google Analytics when added
      // window.gtag && window.gtag('consent', 'update', { analytics_storage: 'granted' })
    }
  }
}
